/*
 * smooth-hash-scroll.js
 *
 * Intercepts clicks on any in-page anchor link (href="#…") and smooth-scrolls
 * to the target instead of letting the browser do an instant native jump.
 *
 * Works alongside scroll-anchor.js:
 *  - This file handles the source side (the click).
 *  - scroll-anchor.js handles the target side (centering correction on cross-page
 *    hash loads). We use history.pushState instead of location.hash so hashchange
 *    does not fire — preventing scroll-anchor.js from overriding the smooth scroll
 *    with an instant jump mid-animation.
 *
 * Alignment: mirrors scroll-anchor.js. With data-align="center" the parent
 * section is centered in the viewport — but only when it fits clear of the
 * sticky header (height <= viewport - 2x header). A section taller than that
 * (the common case on mobile, where it exceeds the viewport) would strand the
 * user mid-section if centered, so it falls back to top-aligning the anchor
 * below the header. Without data-align the anchor is always top-aligned. Either
 * way the header offset comes from the anchor's CSS scroll-margin-top.
 *
 * Reduced motion: falls through to instant behavior when the OS/browser reports
 * prefers-reduced-motion: reduce.
 */
(function () {
  if (typeof document === 'undefined') return;

  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const hash = link.getAttribute('href');
    if (!hash || hash === '#') return;

    const anchorEl = document.querySelector(hash);
    if (!anchorEl) return;

    e.preventDefault();

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior = reducedMotion ? 'instant' : 'smooth';
    const alignCenter = anchorEl.dataset.align === 'center';

    const section =
      anchorEl.closest('[data-section-type]') ||
      anchorEl.closest('.shopify-section') ||
      anchorEl;

    // Center only when the whole section fits clear of the sticky header.
    // Otherwise (e.g. a section taller than the viewport on mobile) top-align
    // the anchor below the header so the heading isn't scrolled off the top.
    // The anchor's scroll-margin-top resolves --header-height, so block:'start'
    // lands it right below the header with no header math here.
    const headerOffset = parseFloat(getComputedStyle(anchorEl).scrollMarginTop) || 0;
    const fitsCentered =
      section.getBoundingClientRect().height <= window.innerHeight - headerOffset * 2;

    if (alignCenter && fitsCentered) {
      section.scrollIntoView({ behavior, block: 'center' });
    } else {
      anchorEl.scrollIntoView({ behavior, block: 'start' });
    }

    history.pushState(null, '', hash);
  });
})();
